<template>
  <span @click="disabled ? null : $emit('click', $event)">
    <template v-if="!disabled">
      <template v-if="href">
        <a
          class="link-icon"
          :class="{
            'link-icon_bold': bold,
            'link-icon_grey': grey,
            'link-icon_dark-blue': darkBlue
          }"
          :href="href"
          :target="target"
        >
          <icon v-if="icon" :name="icon" width="16" height="16" />
          <div class="link-icon__text"><slot /></div>
        </a>
      </template>

      <template v-else>
        <router-link
          class="link-icon"
          :class="{
            'link-icon_bold': bold,
            'link-icon_grey': grey,
            'link-icon_dark-blue': darkBlue
          }"
          :to="to"
          :target="target"
        >
          <icon v-if="icon" :name="icon" width="16" height="16" />
          <div class="link-icon__text"><slot /></div>
        </router-link>
      </template>
    </template>

    <template v-else>
      <span
        class="link-icon link-icon_disabled"
        :class="{
          'link-icon_bold': bold,
          'link-icon_grey': grey,
          'link-icon_dark-blue': darkBlue
        }"
      >
        <icon v-if="icon" :name="icon" width="16" height="16" />
        <div class="link-icon__text"><slot /></div>
      </span>
    </template>
  </span>
</template>

<script>
export default {
  name: "LinkIcon",
  props: {
    icon: {
      type: String,
      required: false,
      default: null
    },

    bold: {
      type: Boolean,
      default: false
    },

    grey: {
      type: Boolean,
      default: false
    },

    darkBlue: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    href: {
      type: String,
      default: ""
    },

    to: {
      default: () => {
        return {};
      }
    },

    target: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/media";

.link-icon {
  display: inline-flex;
  align-items: flex-start;
  text-decoration: none;

  .svg-icon {
    color: #009ee3;
    margin-right: 10px;
    flex-shrink: 0;

    position: relative;
    top: 0.15em;
  }

  &__text {
    font-size: 13.5px;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: 0.15px;
    color: #009ee3;

    @include respond-down(md) {
      font-size: 12px;
    }
  }

  &_bold &__text {
    font-weight: 500;
  }

  &_grey &__text,
  &_grey .svg-icon {
    color: #6d7179;
  }

  &_dark-blue &__text,
  &_dark-blue .svg-icon {
    color: #005197;
  }

  &_disabled {
    &,
    .svg-icon {
      filter: grayscale(1);
      opacity: 0.8;
    }

    cursor: default;
  }
}
</style>
